import { AxiosHeaders } from "axios";
import api from "./api";
import { setAxiosHeader, setAxiosHeader4Post } from "./serviceMain";

export type EditAccount = {
    firstName: string;
    lastName: string;
    email: string;
}

export async function editAccount(request: EditAccount) {

//   const headers: AxiosHeaders = new AxiosHeaders()
//   headers.set('Content-Type', 'application/json');
//   headers.set('Access-Control-Allow-Origin', '*');
//   headers.set('Accept', 'application/json');

const body = {
    firstName: request.firstName,
    lastName: request.lastName,
    email: request.email,
  };

  const url = '/v3/account/profile';

  //return api.post(url, JSON.stringify(request), { headers: setAxiosHeader(url) });

  let status:number = 0;

  await api.post(`${url}`, JSON.stringify(body), { 
    headers: setAxiosHeader4Post(body),
    }).then((response)=> {
    status = response?.status;
  });

  if(status === 200) {
    return 'OK';
  } else {
    return 'KO';
  }

};